import { ServerCampaignAssets } from './types'

export const resolveCampaignAssetsDown = (res: ServerCampaignAssets) =>
  res.campaignAssets.fields
